import Vue from 'vue'
import moment from 'moment'

import 'moment/locale/zh-cn'
moment.locale('zh-cn')


Vue.filter('NumberFormat', function (value) {
    if (!value) {
        return '0'
    }
    const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
    return intPartFormat
})

// 每3位逗号隔开，保留2位小数
Vue.filter('MoneyFormat', function (value) {
    if (!value) {
        return '0.00'
    }
    const decimalFormat = value.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    return decimalFormat
})

// // 每3位逗号隔开，保留2位小数
// Vue.filter('MoneyFormat_W', function (value) {
//     if (!value) {
//         return '0.00'
//     }
//     if (value>10000){
//         return (value/10000).toFixed(2) +"万元"
//     }else{
//         return value+"元"
//     }

//     // const decimalFormat = value.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
//     // return decimalFormat
// })
// 每3位逗号隔开，保留2位小数
Vue.filter('MoneyFormat_W', function (value) {
    if (!value) {
        return '0.00'
    }
    const decimalFormat = (value / 10000).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    return decimalFormat
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    if (dataStr) {
        return moment(dataStr).format(pattern)
    }
})
Vue.filter('moment_m', function (dataStr, pattern = 'YYYY-MM-DD HH:mm') {
    if (dataStr) {
        return moment(dataStr).format(pattern)
    }
})
Vue.filter('moment_mm', function (dataStr, pattern = 'MM-DD HH:mm') {
    if (dataStr) {
        return moment(dataStr).format(pattern)
    }

})
// 只显示日期部分
Vue.filter('moment_d', function (dataStr, pattern = 'YYYY-MM-DD') {
    if (dataStr) {
        return moment(dataStr).format(pattern)
    }

})
Vue.filter('jsonfmt', function (dataStr) {

    return JSON.parse(dataStr)
})

Vue.filter('getFirstName', function (dataStr) {
    let substr = '';
    if (dataStr) {
        substr = dataStr.substring(1, dataStr.length)
    }
    return substr;
})